import { ImageSourceHelper } from '@sortlist-frontend/media';
import { generateDefaultSeo } from 'next-seo/pages';
import Head from 'next/head';

const defaultSeoImage = ImageSourceHelper.fromPath('/_img/default/default-meta.webp', { width: 1200 });

// This tag is used to populate the whole site with default values
export const GlobalSeoTag = () => {
  const seoTags = generateDefaultSeo({
    title: 'Sortlist',
    description: 'Building Great Business Stories',
    openGraph: {
      siteName: 'Sortlist',
      type: 'website',
      description: 'Building Great Business Stories',
      images: [
        {
          url: defaultSeoImage,
        },
      ],
    },
    twitter: {
      handle: '@charlesdg',
      site: '@Sortlist',
      cardType: 'summary',
    },
    facebook: {
      appId: '614655231979033',
    },
    additionalMetaTags: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
      },
      {
        property: 'fb:admins',
        content: '70569527',
      },
    ],
  });

  return <Head>{seoTags}</Head>;
};
